<template>
  <div class="print-detail-wrapper">
    <!--  加载 -->
    <div class="loading" v-show="!file">
      <van-loading type="spinner" />
    </div>
    <!--  内容 -->
    <div class="content" v-if="file">
      <div class="print-header">
        <a
          :href="`/treasure/print/cloud/api/print/downLoadFileForH5?printFile=${file}&platform=${platform}&busKey=${busKey}`"
          @click="gotoView()"
        >
          <div class="img">
            <img :src="pdfImg" alt />
          </div>
          <div class="title">{{file}}</div>
        </a>
      </div>

      <!-- 温馨提示 -->
      <div class="tip">
        <p class="title">温馨提示：</p>
        <p>移动打印仅支持常规的打印设置，如需高级打印设置，请使用电脑端打印。</p>
        <p>打印任务发送后，请到各楼层的打印机处二维码或者刷卡进行打印。</p>
      </div>
      <!-- <div>
        <van-button type="alert" size="small" style="width:100%;">取消</van-button>
      </div>-->
    </div>
    <div class="print-footer">
      <!-- 箭头 -->
      <div class="arrow" @click="isShowFooter=!isShowFooter">
        <img class="arrowDown" :src="arrowDown" :class="{'isUp': !isShowFooter}" />
        <img class="arrowDownDark" :src="arrowDownDark" :class="{'isUp': !isShowFooter}" />
      </div>
      <!-- 打印设置 -->
      <div :class="{'print-config': true, 'isDown': !isShowFooter}">
        <div class="config-item">
          <van-row>
            <van-col span="8">
              <span class="label">色彩模式</span>
            </van-col>
            <van-col span="16">
              <van-radio-group v-model="color"  class="radio-box" direction="horizontal" style="float: right">
                 <van-radio name="Mono"><span class="text">黑白</span></van-radio>
                 <van-radio name="Color" ><span class="text">彩色</span></van-radio>
                 <!-- <van-radio name="Mono">
                    <template slot="icon" slot-scope="props">
                      <img class="radioIcon" :src="props.checked ? radioChecked : radioIcon" />
                      <img
                        class="radioDarkIcon"
                        :src="props.checked ? radioChecked : radioDarkIcon"
                      />
                    </template>
                    <span class="text">黑白</span>
                  </van-radio>
                </van-col>
                <van-col span="8">
                  <van-radio name="Color">
                    <template slot="icon" slot-scope="props">
                      <img class="radioIcon" :src="props.checked ? radioChecked : radioIcon" />
                      <img
                        class="radioDarkIcon"
                        :src="props.checked ? radioChecked : radioDarkIcon"
                      />
                    </template>

                    <span class="text">彩色</span>
                  </van-radio> -->
                
              </van-radio-group>
            </van-col>
          </van-row>
        </div>
        <div class="config-item">
          <van-row>
            <van-col span="8">
              <span class="label">打印份数</span>
            </van-col>
            <van-col span="16" style="text-align: center;">
              <van-col offset="12" span="4">
                <van-icon
                  class="reduceIcon"
                  @click="printNum=printNum-1<1? printNum : printNum-1"
                  :name="reduceIcon"
                  size="0.58rem"
                />
                <van-icon
                  class="reduceDarkIcon"
                  @click="printNum=printNum-1<1? printNum : printNum-1"
                  :name="reduceDarkIcon"
                  size="0.58rem"
                />
              </van-col>
              <van-col span="4">
                <div class="text">{{printNum}}</div>
              </van-col>
              <van-col span="4">
                <van-icon @click="printNum=printNum+1" :name="addIcon" size="0.58rem" />
              </van-col>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- 发送到打印机 -->
      <div data-v-db294594 class="handle_box">
        <a data-v-db294594 href="javascript:;" class="approve" @click="sendToPrint()">发送到打印机</a>
      </div>
      <!-- <div style="padding: 0 0.4rem; box-sizing: border-box;">
        <van-button class="btn" type="info" @click="sendToPrint()">发送到打印机</van-button>
      </div>-->
    </div>
  </div>
</template>
<script>
import { sendPrint, isPrinted , getFileStream} from '@/api/print'
import arrowUp from '@/assets/img/icon/arrow-up.png'
import arrowDown from '@/assets/img/icon/arrow-down.png'
import arrowDownDark from '@/assets/img/icon/arrow-down-dark.png'
// import radioIcon from '@/assets/img/icon/radio.png'
// import radioDarkIcon from '@/assets/img/icon/radio-dark.png'
// import radioChecked from '@/assets/img/icon/radioChecked.png'
import addIcon from '@/assets/img/icon/add.png'
import reduceIcon from '@/assets/img/icon/reduce.png'
import reduceDarkIcon from '@/assets/img/icon/reduce-dark.png'
import pdfImg from '@/assets/img/pdf.png'

export default{
  data(){
    return {
      pdfImg,
      arrowDown,
      arrowUp,
      // radioIcon,
      // radioDarkIcon,
      // radioChecked,
      addIcon,
      reduceIcon,
      arrowDownDark,
      reduceDarkIcon,
      isShowFooter: false,
      printNum: 1,
      color: "Mono",
      // options: [{id: 1, text: '横向'},{id: 2, text: '竖向'}],
      // optionsColor: [{id: 'Mono', text: '黑白'},{id: 'Color', text: '彩色'}],
      file:'',
      jobId: '',
      platform:'',
      busKey: ''
    }
  },
  watch: {
    "$route"(){
      this.file = this.$route.query.file ;
      this.platform = this.$route.query.platform ;
      this.busKey = this.$route.query.busKey ;
    }
  },
  mounted(){
      this.file = this.$route.query.file ;// '2-page.pdf'
      this.platform = this.$route.query.platform ;// '2-page.pdf'
      this.busKey = this.$route.query.busKey ;// '2-page.pdf'
  },
  methods:{
    hulue(e){
      e.preventDefault();
    },
    // 发送到打印机
    sendToPrint(){
      let data = {
        copy: this.printNum,
        color: this.color,
        printFile: this.file
        // "printFile":"https://app.is.qihoo.net/static/icon/workbench-hr-vacation.png"
      }

      sendPrint(data).then(res => {
        const { data } = res;
        if(data.code == 200){
          if(data.data.code == "0000"){
            this.jobId = data.data.jobId;
            this.$toast('打印状态查询中...')
            this.getIsPrinted();
          } else if(data.data.code !='0009'){
            this.$toast.fail(data.message ? data.message : '');
          }
        } else {
          this.$toast.fail('请稍后重试！')
        }
        
      })
    },
    // 预览
    gotoView(){
      let data = {
        printFile: this.file
      }
      iqh.preViewFilePrint && iqh.preViewFilePrint(data);
    },
    // 确认发送成功
    getIsPrinted(){
      let params = {
        jobId: this.jobId
      }
      isPrinted(params).then( ({data}) => {
        if(data.code == 200){
          if(data.data == '0009'){
            setTimeout(() => {
              this.getIsPrinted();
            }, 3000);
          } else if(data.data == "0000"){
            this.$toast.success(data.message ? data.message : '');
          } else {
            this.$toast.fail(data.message ? data.message : '');
          }
        } else {
            setTimeout(() => {
              this.getIsPrinted();
            }, 3000);
         }
        
      })

    }
  }
}
</script>


<style lang="scss" scoped>
.print-detail-wrapper {
  /* display: flex;
  flex-direction: column; */
  /* overflow: hidden; */
  
  height: 100vh;
}
/* .content-wrapper {
  height: 100vh;
  width: 100%;
} */
.content {
  box-sizing: border-box;
  height: calc(100vh - 121px);
  padding: 0px 16px ;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100vh;
  text-align: center;
  line-height: 40vh;
}
.config-item {
  position: relative;
  padding: 12px 0;
  // margin: 0 20px;
  line-height: 24px;
  border-bottom: 1px solid $border-color;
  &:last-child {
    margin-bottom: 16px;
  }
  .label,
  .text {
    font-size: 14px;
    color: $value-color;
    letter-spacing: 0.2px;
    line-height: 24px;
  }
  .label {
    font-size: 15px;
  }
}

.print-header {
  background: #fff;
  padding: 30px 18px ;
  // border-radius: 8px;
  .img {
    margin-bottom: 20px;
    text-align: center;
    img {
      width: 64px;
      height: 64px;
      display: inline;
    }
  }
  .title {
    font-size: 15px;
    color: $link-a;
    padding: 0 10px;
  }
}
.tip {
  font-size: 14px;
  color: $des-color;
  line-height: 22px;
  overflow: hidden;
  margin-top: 17px;
  .title {
    font-size: 15px;
  }
  // p {
  //   margin: 12px 0;
  // }
}
.print-footer {
  position: fixed;
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  background: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  // border-radius: 14px 14px 0 0;
  padding: 12px 16px 40px;
  .arrow {
    line-height: 24px;
    height: 24px;
    text-align: center;
    margin-bottom: 18px;
    cursor: pointer;
    img {
      display: inline;
      height: 24px;
      transition: all 0.3s ease;
      transform: rotate(0);
      &.isUp {
        transform: rotate(180deg);
      }
    }
    .arrowDownDark {
      display: none;
    }
  }
  .print-config {
    transition: all 0.3s ease;
    overflow: hidden;
    /* transform: translateY(0); */
    height: 118px;
    &.isDown {
      /* transform: translateY(100%); */
      height: 0;
    }
  }
  // .radioDarkIcon,
  // .radioIcon {
  //   width: 28px;
  //   height: 28px;
  //   margin-top: -4px;
  // }
  // .radioDarkIcon {
  //   display: none;
  // }
  .reduceDarkIcon {
    display: none;
  }
  .btn {
    width: 100%;
    box-sizing: border-box;
    /* margin: 0 14px; */
    background: $link-a;
    border-radius: 22px;
    font-size: 16px;
    box-sizing: border-box;
    height: 44px;
    color: #fff;
    cursor: pointer;
    font-weight: bold;
  }
}

.handle_box a:first-child{
  border: none;
  color: #fff;
  background: $link-a;
  border-radius: 4px;
}

@mixin detail-dark {
  .content-wrapper {
    background: #000;
  }
  .print-header {
    background: #1a1a1a;
    .title {
      opacity: 0.8;
    }
  }
  .tip {
    color: #444;
  }
  .print-footer {
    background: #1a1a1a;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    .radioDarkIcon,
    .arrowDownDark,
    .reduceDarkIcon {
      display: inline;
    }
    .arrowDown,
    .reduceIcon,
    .radioIcon {
      display: none;
    }
    .text,
    .label {
      color: #888;
    }
    .config-item {
      border-color: #222;
    }
    .btn {
      opacity: 0.8;
    }
  }
}
</style>
